import { ActiveFlightContextMenuData } from '../../../services/map-interaction-service';
import { FlightContextMenuContent } from './FlightContextMenuContent';

export function ActiveFlightContextMenu(props: { info: ActiveFlightContextMenuData }) {
    return <FlightContextMenuContent id={props.info.flightIds[0]} />;
}
